import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { Calendar, Clock, User, ArrowRight } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
export function BlogListingPage() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-1201" data-mp="xth7pym45bq5">
      <Helmet data-id="element-1202" data-mp="xsxlw6tce36u">
        <title data-id="element-1203" data-mp="xrd31ege48ot">Blog | I75 Audio & Video</title>
        <meta name="description" content="Read the latest news, tips, and insights about home theater, smart home technology, and audio/video solutions from I75 Audio & Video." data-id="element-1204" data-mp="13q7rjv1ywcy" />
      </Helmet>

      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20 mt-16" data-id="element-1205" data-mp="a2ldyvy3k6g9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1206" data-mp="evweygg89t09">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1207" data-mp="3ehbiizdi461d">Our Blog</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-1208" data-mp="3ij6fxssb9z9v">
            Expert insights, tips, and guides for your home entertainment and
            smart technology needs.
          </p>
        </div>
      </div>

      {/* Blog Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-1209" data-mp="3d3ekc2kpj8kd">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1210" data-mp="38auua64u2kyo">
          {blogPosts.map(post => <article key={post.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-1211" data-mp="33ca6552uvrql">
              <div className="p-6 flex flex-col flex-grow" data-id="element-1212" data-mp="2uak4z7j69efm">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4" data-id="element-1213" data-mp="2pcingr1e9n69">
                  <div className="flex items-center gap-1" data-id="element-1214" data-mp="2ke7boarjh2le">
                    <Calendar size={14} data-id="element-1215" data-mp="2kfs49uuambgm" />
                    <span data-id="element-1216" data-mp="nm75b3pt1q7r">{post.date}</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-1217" data-mp="njkvexffyymd">
                    <Clock size={14} data-id="element-1218" data-mp="invvgsziffpj" />
                    <span data-id="element-1219" data-mp="ikrjh9fszfob">{post.readTime}</span>
                  </div>
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-1220" data-mp="2d0pyxwejylaa">
                  <Link to={`/blog/${post.slug}`} className="hover:text-blue-600 transition-colors" data-id="element-1221" data-mp="2hv2lwgf8meqs">
                    {post.title}
                  </Link>
                </h2>

                <p className="text-gray-600 mb-6 line-clamp-3 flex-grow" data-id="element-1222" data-mp="2vtakstvu3q4l">
                  {post.excerpt}
                </p>

                <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-1223" data-mp="30sn63a724p52">
                  <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-1224" data-mp="2lu30tnulgx8i">
                    <User size={14} data-id="element-1225" data-mp="2qteir06p68ro" />
                    <span data-id="element-1226" data-mp="2qsmoptsr0j3i">{post.author}</span>
                  </div>
                  <Link to={`/blog/${post.slug}`} className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 text-sm" data-id="element-1227" data-mp="1afo9lf0q0ub6">
                    Read More <ArrowRight size={16} className="ml-1" data-id="element-1228" data-mp="3tlic6on15g8m" />
                  </Link>
                </div>
              </div>
            </article>)}
        </div>
      </div>

      <Footer data-id="element-1229" data-mp="6idjc5op0gqe" />
    </div>;
}